import * as React from 'react';
import { OrderSummary } from '../../../../transportation/models/shared/order-summary';
import SelectableOrderRow from './SelectableOrderRow';

interface IProps {
    orders: OrderSummary[];
    showExtraData: boolean;
}

export const OrderGroupTable = (props: IProps) => {

    return props.orders && props.orders.length > 0 
            ? <div className="row">
                        <div className="col">           
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Order ID</th>
                                        <th>Qty</th>
                                        <th>Description</th>
                                        <th>Job Name</th>
                                        <th>Units</th>
                                        <th>Weight</th>
                                        <th>Singles</th>
                                        <th>Feet</th>
                                        {
                                            props.showExtraData
                                                ? <React.Fragment>
                                                    <th>Section</th>
                                                    <th>Track</th>
                                                    <th>Hardware</th>
                                                </React.Fragment>
                                                : null
                                        }
                                    </tr>
                                </thead>
                                <tbody>                        
                                {
                                    props.orders.map((itm: OrderSummary) =>
                                        <SelectableOrderRow
                                            key={ itm.id }
                                            showExtraColumns={ props.showExtraData }
                                            orderItem={ itm }
                                        />
                                    )                     
                                }                        
                                </tbody>
                            </table>                        
                        </div>
                    </div> 
            : null;
};
